/**
 * SupportHowItWorks — «Как это работает» collapsible accordion shown in the
 * chat empty-state welcome screen of SupportWidget.
 *
 * Extracted verbatim from SupportWidget.jsx (refactor, no behavior change):
 * owns its own open/closed toggle state — SupportWidget no longer needs to
 * track or reset it.
 */
import { useState } from 'react'
import { ChevronDown, HelpCircle } from 'lucide-react'

export default function SupportHowItWorks() {
    const [open, setOpen] = useState(false)

    return (
        <div style={{ width: '100%', marginTop: 8 }}>
            <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '5px 10px',
                    border: '1px solid var(--color-border)',
                    borderRadius: 10,
                    background: 'var(--color-bg-elevated)',
                    color: 'var(--color-text-muted)',
                    font: 'inherit',
                    fontSize: 12,
                    fontWeight: 500,
                    cursor: 'pointer',
                    transition: 'border-color 140ms ease, color 140ms ease, background 140ms ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'var(--color-accent)'
                    e.currentTarget.style.color = 'var(--color-accent)'
                    e.currentTarget.style.background = 'var(--color-accent-bg)'
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'var(--color-border)'
                    e.currentTarget.style.color = 'var(--color-text-muted)'
                    e.currentTarget.style.background = 'var(--color-bg-elevated)'
                }}
            >
                <HelpCircle size={13} aria-hidden="true" />
                Как это работает
                <ChevronDown
                    size={13}
                    aria-hidden="true"
                    style={{
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 200ms ease',
                    }}
                />
            </button>

            {open && (
                <div
                    style={{
                        marginTop: 8,
                        padding: '12px 14px',
                        borderRadius: 12,
                        border: '1px solid var(--color-border)',
                        background: 'var(--color-bg-elevated)',
                        textAlign: 'left',
                        fontSize: 12.5,
                        lineHeight: 1.55,
                        color: 'var(--color-text-secondary)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                    }}
                >
                    <div>
                        <div style={{ fontWeight: 600, color: 'var(--color-text)', marginBottom: 3, fontSize: 12 }}>
                            Как написать
                        </div>
                        Опишите: что делали, что ожидали, что получилось. Прикрепите скриншот, запись экрана, голосовое (до 60 сек) или файл. Личные данные на скриншотах закрашиваются автоматически. Одно обращение — одна проблема.
                    </div>
                    <div>
                        <div style={{ fontWeight: 600, color: 'var(--color-text)', marginBottom: 3, fontSize: 12 }}>
                            Что сделает помощник
                        </div>
                        Ответит сразу, проведёт по шагам с уточняющими вопросами, заведёт починку если поломка, передаст человеку если нужно.
                    </div>
                    <div>
                        <div style={{ fontWeight: 600, color: 'var(--color-text)', marginBottom: 3, fontSize: 12 }}>
                            Статусы обращения
                        </div>
                        Новый → Триаж → Уточнение <span style={{ color: 'var(--color-text-muted)' }}>(здесь ждёт ваш ответ)</span> → В работе → Исправлено → Подтверждено → Закрыто
                    </div>
                </div>
            )}
        </div>
    )
}
